import { shop } from '@/commonTypes';
import AppLink from '@/components/common/AppLink';
import React from 'react';
import styles from '../styles.module.css';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import RateComponent from '@/components/common/RateComponent';
import { blogBg } from '@/functions/formats';
import MainIcons from '@/icons/main';

export default function NearByStore({
  store,
  index,
  className = '',
  activeFillColor,
  titleClass = '',
}: {
  store?: shop;
  index: number;
  className?: string;
  activeFillColor?: string;
  titleClass?: string;
}) {
  return (
    <AppLink href={`/shops/${store?.slug}`} key={store?.name}>
      <PageCardHeader
        className={`${styles.card} ${className}`}
        title={store?.title}
        titleClass={`${styles.titleClass} ${titleClass}`}
        text={
          <div className={styles.meta}>
            <span className={styles.rating} style={{ color: `${activeFillColor}` }}>
              {/* <MainIcons.starIcon width={'21px'} height={'21px'} /> */}
              <RateComponent
                number={1}
                rate={Number(store?.rating)}
                className="w-auto"
                activeFillColor={activeFillColor}
              />
              {store?.rating}
            </span>

            <span className={styles.distance}>{store?.distance}</span>
          </div>
        }
        backgroundIcon={blogBg(index)}
        icon={<MainIcons.shopIcon width={'21px'} height={'21px'} fill="var(--paper)" />}
      />
    </AppLink>
  );
}
